export default __webpack_public_path__ + "static/media/logo-mandirisyariah.023d787e.png";